import { REACHABILITY } from '../../graphql/queries/vulnerability';
import NRReachabilityEvidenceContainer from './NRReachabilityEvidenceContainer';
import { useParams } from 'react-router-dom';

function NRReachabilityContainer({ advisoryId, identificationIds, componentName, severityColor }) {
  const { componentId: assetId } = useParams();

  return (
    <NRReachabilityEvidenceContainer
      query={REACHABILITY}
      variables={{ args: { advisoryId, assetId, identificationIds } }}
      qlObjKey="getVulnReachability"
      componentName={componentName}
      severityColor={severityColor}
      showTerminalEndIcon={true}
    />
  );
}
export default NRReachabilityContainer;
